import type { FC } from "react";
import { useOutletContext } from "react-router-dom";
import { PortfolioListPage } from "web_myplann/Portfolio/Pages/PortfolioListPage";
import type { PortfolioTabContext } from "web_myplann/Portfolio/Pages/PortfolioTabsLayout";

export const PortfolioListTab: FC = () => {
	const { activeSort, setIsLoading } = useOutletContext<PortfolioTabContext>();
	return (
		<PortfolioListPage activeSort={activeSort} setIsLoading={setIsLoading} />
	);
};
